import React from 'react';

import CustomTooltip from './CustomTooltip';
import { ToolTipProps } from './types';

import './styles.scss';

interface Props extends ToolTipProps {
  keys: string[] | React.ReactNode[] | React.ReactElement[];
  keyClassName?: string;
}

export const shortcutTooltipTitle = (
  keys: string[] | React.ReactNode[] | React.ReactElement[],
  title: string | React.ReactNode,
  keyClassName?: string
) => {
  return (
    <div className="flex justify-center items-center w-full gap-2 ">
      <p className="flex justify-center items-center">{title}</p>
      {keys && keys?.length > 0 && (
        <div className="custom-shortcut-tooltip-key-section">
          {keys.map((key, i) => {
            return (
              <span className={`custom-shortcut-tooltip-key ${keyClassName}`} key={i}>
                {key}
              </span>
            );
          })}
        </div>
      )}
    </div>
  );
};

const CustomShortcutTooltip: React.FC<Props> = ({
  children,
  arrow = true,
  placement = 'bottom',
  light = false,
  show = true,
  opened,
  tooltipStyle = {},
  title,
  keys = [],
  keyClassName = '',
  ...rest
}) => {
  return (
    <CustomTooltip
      show={show}
      light={light}
      opened={opened}
      tooltipStyle={tooltipStyle}
      arrow={arrow}
      placement={placement}
      title={shortcutTooltipTitle(keys, title, keyClassName)}
      {...rest}>
      {children}
    </CustomTooltip>
  );
};

export default CustomShortcutTooltip;
